import { newOrderLista } from "global/utils/orderData";
import { useEffect, useState } from "react";
import { orderForColumn } from "../../funtions/acordion";
import { pagination } from "../../funtions/pagination";
import {
  Column,
  ColumnMoveBorder,
  ColumnTopZone,
  ContainerTop,
  SearcherZone,
} from "./localStyle";

const Top = ({ global, config, setGlobal }) => {
  //#region ------ useStates --------
  const [mouseLive, setMouseLive] = useState(false);
  const [lenCol, setLenCol] = useState({ all: config.width  / config.column.length });
  const [copyLenCol, setCopyLenCol] = useState(lenCol);
  const [borderActive, setBorderActive] = useState(false);
  const [acordeonCol, setAcordeonCol] = useState([]);
  //#endregion --- useStates --------

  //#region ------ funciones --------
  const onMouseUp = (e) => {
    // setMouseLive(false);

    if (typeof global.indexMove === "number") {
      setGlobal({
        ...global,
        initialLen: {
          ...global.initialLen,
          [global.indexMove]: true,
        },
        copyLenCol: { ...copyLenCol, ...lenCol },
        indexMove: false,
      });
    } else {
      setGlobal({
        ...global,
        indexMove: false,
        copyLenCol: { ...copyLenCol, ...lenCol },
      });
    }
    setMouseLive(false);
    setCopyLenCol(lenCol);
  };
  const onMouseDown = (e, key) => {
    setGlobal({ ...global, clientX: e.clientX, indexMove: key });
    setMouseLive(true);
  };
  const onMouseMove = (e, key) => {
    if (mouseLive) {
      let client = e.clientX - global.clientX;
      let initialLen = copyLenCol[global.indexMove]
        ? copyLenCol[global.indexMove]
        : lenCol.all;
      let initialLenNext = copyLenCol[global.indexMove + 1]
        ? copyLenCol[global.indexMove + 1]
        : lenCol.all;
      let lenNext = global.column[global.indexMove + 1]
        ? global.indexMove + 1
        : false;
      const resul =
        client >= 0 ? initialLen + client : initialLen - client * -1;
      if (resul >= 100) {
        if (lenNext) {
          setLenCol({
            ...lenCol,
            [global.indexMove]:
              client >= 0 ? initialLen + client : initialLen - client * -1,
            [lenNext]: initialLenNext - client,
          });
        } else {
          setLenCol({
            ...lenCol,
            [global.indexMove]:
              client >= 0 ? initialLen + client : initialLen - client * -1,
            [lenNext]: initialLenNext + client * -1,
          });
        }
      }
    }
  };
  const ondropcolumn = (e, key) => {
    let columnCurrent = e.target.innerText
      .toLowerCase()
      .replaceAll("\r", "")
      .replaceAll("\n", "");

    let newColumn = e.dataTransfer
      .getData("text")
      .toLowerCase()
      .replaceAll("\r", "")
      .replaceAll("\n", "");

    let indexCurrent;
    let indexNew;
    let column = global.column; 
    column.map((col, index) => {
      if (col.name === columnCurrent) {
        indexCurrent = index;
      }
      if (col.name === newColumn) {
        indexNew = index;
      }
    });
    let currentCol = column[indexCurrent];
    let newCol = column[indexNew];
    column[indexNew] = currentCol;
    column[indexCurrent] = newCol;
    setGlobal({...global, column: [...column]});
  };

  const ondrop = (e) => {
    let columnName = e.dataTransfer.getData("text");
    if (!acordeonCol.includes(columnName) && acordeonCol.length < 1) {
      const resultado = pagination(orderForColumn(global.data, columnName.toLowerCase()), 13);
      setAcordeonCol([...acordeonCol, columnName]);
      setGlobal({ ...global, agrupamietoColumn: [...acordeonCol, columnName], pagination: resultado });
    }
  };
  const ondeleteAcordionCol = (col) => {
    let newCol = acordeonCol.filter((e) => e !== col);
    setAcordeonCol(newCol);
    setGlobal({ ...global, agrupamietoColumn: newCol, pagination: pagination(config.data, 13) });
  };
  const ondragend = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const onChange = (e) => {
    let value = e.target.value;
    let newColumn = global.column.map((e) => e.name);
    let filtrado = newOrderLista(global.data, newColumn, value);
    setGlobal({...global, pagination: pagination(filtrado, 13)});
  }; 
  const handleChangeCheckbox = (e) => {
    if(e.target.checked){
      const data = config.data.map(e => e.id); 
      setGlobal({...global, dataSelected: data })
    }else {
      setGlobal({...global, dataSelected: [] })
    }
  }
  //#endregion --- funciones --------


  //#region ------ useEffects --------




  // const [lenCol, setLenCol] = useState({ all: config.width  / config.column.length });
  // const [copyLenCol, setCopyLenCol] = useState(lenCol);

  useEffect(() => {
    if(config?.colWidth){
      let config = {}; 
      global.column.map((col, key) => {
        config = {
          ...config, 
          [key]: col.width
        }
      })    
      setLenCol({...config}); 
      setCopyLenCol({...config});   
    }
    
  },[config?.colWidth])
  //#endregion --- useEffects --------


  return (
    <ContainerTop>
      <SearcherZone>
        <div
          className="drag-and-drop-columns"
          onDrop={ondrop}
          onDragOver={ondragend}
        >
          {acordeonCol.length === 0 ? (
            <span>Arrastrar hasta aquí las columnas para agrupar</span>
          ) : (
            acordeonCol.map((e, key) => {
              return (
                <div key={key} className="acordeon-col">
                  {e}{" "}
                  <span className="cruz" onClick={() => ondeleteAcordionCol(e)}>
                    X
                  </span>
                </div>
              );
            })
          )}
        </div>
        <div className="searcher">
          <span>Buscador:</span>
          <input  placeholder="Escribi algo.." onChange={onChange} id={"buscador-tabla-por-defecto"}/>
        </div>
      </SearcherZone>
      <ColumnTopZone mouseLive={mouseLive} borderActive={borderActive}>
        <div className="view">
          {global.column.map((col, key) => {
            return (
              <Column
                mouseLive={mouseLive}
                width={copyLenCol[key] ? copyLenCol[key] :  copyLenCol["all"]}
                maxWidth={lenCol.all}
                draggable
                onDragStart={(e) => {
                  e.dataTransfer.setData("text", e.target.innerText);
                }}
                onDragOver={ondragend}
                onDrop={(e) => {
                  ondropcolumn(e, key);
                }}
              >
                {col.name === "" ? <input type={"checkbox"} onClick={handleChangeCheckbox} /> : col.name}
                <div
                  className="border-new"
                  // onMouseDown={(e) => onMouseDown(e, key)}
                  // onMouseUp={(e) => onMouseUp(e, key)}
                  // onMouseMove={(e) => onMouseMove(e, key)}
                  onMouseOver={() => {
                    if (!borderActive) {
                      setBorderActive(true);
                    }
                  }}
                ></div>
              </Column>
            );
          })}
        </div>
        <div className="border-view">
          {global.column.map((col, key) => {
            return (
              <Column
                mouseLive={mouseLive}
                width={lenCol[key] ? lenCol[key] : lenCol["all"]}
                second={global.indexMove === key}
                maxWidth={lenCol.all}
              >
                {/* {col.name === "" ? <input type={"checkbox"} /> : col.name} */}
                <div
                  className="content-border"
                  onMouseOver={() => {
                    if (borderActive) {
                      setBorderActive(false);
                    }
                  }}
                ></div>

                <div
                  className="border"
                  onMouseDown={(e) => onMouseDown(e, key)}
                  onMouseUp={(e) => onMouseUp(e, key)}
                  onMouseMove={(e) => onMouseMove(e, key)}
                ></div>
              </Column>
            );
          })}
        </div>
      </ColumnTopZone>
    </ContainerTop>
  );
};

export default Top;
